/**
 * custom-judgeme.js
 *
 * Đổi format preview badge "Star Ratings" trên TRANG PRODUCT:
 *   "(4.8/5) based on 45 reviews"  ->  "4.8 Stars (45 Reviews)  Click to scroll to reviews"
 * Lấy số THẬT từ data-average-rating + data-number-of-reviews của Judge.me.
 * Chỉ chạy khi có widget review đầy đủ (#judgeme_product_reviews) => chắc chắn là trang product.
 */
(function () {
  'use strict';

  const TEXT_CLASS = 'custom-jdgm-badge-text';
  const REVIEWS_SELECTOR = '#judgeme_product_reviews';
  const BADGE_WRAPPER = '.jdgm-widget.jdgm-preview-badge';

  function isProductPage() {
    return !!document.querySelector(REVIEWS_SELECTOR);
  }

  function scrollToReviews() {
    const target = document.querySelector(REVIEWS_SELECTOR);
    if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  function reformat(wrapper) {
    const badge = wrapper.querySelector('.jdgm-prev-badge');
    if (!badge) return;

    const rating = parseFloat(badge.getAttribute('data-average-rating'));
    const count = parseInt(badge.getAttribute('data-number-of-reviews'), 10);
    if (!isFinite(rating) || !isFinite(count) || count <= 0) return;

    const textEl = badge.querySelector('.jdgm-prev-badge__text');
    if (!textEl) return;

    const desired = rating.toFixed(1) + ' Stars (' + count.toLocaleString('en-US') + ' Reviews)';
    if (textEl.textContent.trim() !== desired) {
      textEl.textContent = desired;
    }
    textEl.classList.add(TEXT_CLASS);
  }

  function initBadges() {
    if (!isProductPage()) return;
    document.querySelectorAll(BADGE_WRAPPER).forEach((wrapper) => {
      reformat(wrapper);

      if (!wrapper.dataset.customBadgeBound) {
        wrapper.dataset.customBadgeBound = '1';
        wrapper.style.cursor = 'pointer';
        wrapper.addEventListener('click', scrollToReviews);

        // Judge.me có thể re-render badge và ghi đè text => observe để áp lại format
        const obs = new MutationObserver(() => reformat(wrapper));
        obs.observe(wrapper, { childList: true, subtree: true, characterData: true });
      }
    });
  }

  let tries = 0;
  const MAX_TRIES = 30;

  function waitBadge() {
    if (isProductPage() && document.querySelector(BADGE_WRAPPER + ' .jdgm-prev-badge')) {
      initBadges();
      return;
    }
    if (tries++ < MAX_TRIES) setTimeout(waitBadge, 400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitBadge);
  } else {
    waitBadge();
  }

  document.addEventListener('jdgm.widget.rendered', initBadges);
  document.addEventListener('shopify:section:load', initBadges);
})();
